import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['monthAndYear', 'createdDate', 'totalRequestedAmount']),
  desc: z.boolean(),
});

const affiliateSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.union([z.string(), z.array(z.string())]).optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/affiliate-log/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => affiliateSearchSchema.parse(search),
});

import { useGetAffiliateLog } from '@/features/payment-management/affiliate-log/hooks/useGetAffiliateLog';
import { AffiliateLogTable } from '@/features/payment-management/affiliate-log/table';

function RouteComponent() {
  const { affiliateData, isLoading, pagination, dateRange } = useGetAffiliateLog();

  return (
    <div className="flex flex-col gap-6">
      <AffiliateLogTable data={affiliateData} pagination={pagination} loading={isLoading} dateRange={dateRange} />
    </div>
  );
}
